// extracted by mini-css-extract-plugin
module.exports = {"root":"raT8jW","item":"sMpaak","body":"_2al6SO","link":"_1swuTj","title":"_1sH8lL","street":"yHQ9QY","zip":"_1Wl3iI"};